export default __webpack_public_path__ + "static/itreview-banner-c229950fd156bac369f5291257cf1336.png";